import * as XLSX from 'xlsx';

export const employeesExcelToJson = (fileObj) => {
    // alert(fileObj)
    // const workbook = XLSX.readFile(fileObj);
    // let sheet = workbook.Sheets[0]
    // let data = XLSX.utils.sheet_to_json(sheet)
    // alert(data)
}

export const downloadPdf = (response, pdfName) => {
    try {
        // Create a Blob from the PDF Stream
        const file = new Blob(
            [response.data],
            {type: 'application/pdf'}
        );
        // Build a URL from the file
        const fileURL = URL.createObjectURL(file);
        // Open the URL on new Window
        const link = document.createElement('a');
        link.href = fileURL;
        link.setAttribute('download', pdfName);
        document.body.appendChild(link);
        link.click();
    } catch (e) {
        console.error("Error occurred while downloading file", e);
    }
}
